/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whenwillyoureventtakeplace5Inputs */

const en_whenwillyoureventtakeplace5 = /** @type {(inputs: Whenwillyoureventtakeplace5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When will your event take place?`)
};

const de_whenwillyoureventtakeplace5 = /** @type {(inputs: Whenwillyoureventtakeplace5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann findet dein Event statt?`)
};

/**
* | output |
* | --- |
* | "When will your event take place?" |
*
* @param {Whenwillyoureventtakeplace5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const whenwillyoureventtakeplace5 = /** @type {((inputs?: Whenwillyoureventtakeplace5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whenwillyoureventtakeplace5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_whenwillyoureventtakeplace5(inputs)
	return de_whenwillyoureventtakeplace5(inputs)
});
export { whenwillyoureventtakeplace5 as "whenWillYourEventTakePlace" }